"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderCustomerTypeString = exports.getOrderCustomerType = void 0;
const enums_1 = require("../../enums");
const utils_1 = require("../../utils");
const getOrderCustomerType = (order) => {
    var _a, _b, _c, _d;
    if ((_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.bosCustomer) {
        return (0, utils_1.mapBosApiToNextCustomerType)((_b = order.customer.bosCustomer) === null || _b === void 0 ? void 0 : _b.customerType);
    }
    return typeof ((_c = order === null || order === void 0 ? void 0 : order.customer) === null || _c === void 0 ? void 0 : _c.customerType) === 'number' ? (_d = order === null || order === void 0 ? void 0 : order.customer) === null || _d === void 0 ? void 0 : _d.customerType : enums_1.CustomerType.PRIVATE;
};
exports.getOrderCustomerType = getOrderCustomerType;
const getOrderCustomerTypeString = (order) => enums_1.CustomerType[(0, exports.getOrderCustomerType)(order)];
exports.getOrderCustomerTypeString = getOrderCustomerTypeString;
//# sourceMappingURL=order.js.map